"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAlignment = parseAlignment;

function parseAlignment(alignment) {
  switch (alignment) {
    case 'start':
    case 'end':
      {
        return "flex-".concat(alignment);
      }

    default:
      {
        return alignment;
      }
  }
}